<template>
  <div>
    <div class="jc-page-content">
      <div class="jc-panel-padding">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <jc-form class="jc-table-actionBar-item" :inline="true"  ref="quotaSearchForm" :model="quotaSearchParams">             
              <jc-form-item :label="`${$t('券额码')}${$t('：')}`" prop="number">
                <jc-input v-model.trim="quotaSearchParams.number"></jc-input>
              </jc-form-item>
              <jc-form-item :label="$t('有效时间')">
                <jc-date-picker v-model="daterange"
                                type="daterange"
                                >
                </jc-date-picker>
              </jc-form-item>
               <jc-form-item :label="`${$t('创建时间')}${$t('：')}`">
                <jc-date-picker v-model="createRang"
                                type="daterange"
                                >
                </jc-date-picker>
              </jc-form-item>
             <jc-form-item :label="`${$t('是否支持转赠')}${$t('：')}`" prop="resend" style="margin-left: 0px;">
               <jc-select :placeholder="$t('请选择')" v-model="quotaSearchParams.resend">
                    <jc-option v-for="(item,index) in IS_OR_NOT" :key="index" :label="item.label" :value="item.value"></jc-option>
                </jc-select>
              </jc-form-item>
              <jc-form-item :label="$t('状态_')"  prop="status">
               <jc-select :placeholder="$t('请选择')" v-model="quotaSearchParams.status">
                    <jc-option v-for="(item,index) in STATUS_MAP" :key="index" :label="item.label" :value="item.value"></jc-option>
                </jc-select>
              </jc-form-item>
              <jc-form-item>
                <jc-button @click="query" type="primary">{{$t('查询')}}</jc-button>
                <jc-button @click="reset" >{{$t('重置')}}</jc-button>
                
              </jc-form-item>
            </jc-form>
            
          </div>
          <jc-table style="width:100%" class="quotaRecordList" :data="quotaList">
              <jc-table-column :label="$t('券额码')" >
                <template scope="scope" >{{scope.row.number}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('金额_元_')"  width="80px" prop="fee"></jc-table-column>
              <jc-table-column :label="$t('余额_元_')"  width="80px" prop="balance">
              </jc-table-column>
              <jc-table-column :label="$t('有效时间_')" width="160px" >
                <template scope="scope" ><span>{{scope.row.validStartTime + $t('至')}}</span><br/><span>{{scope.row.validEndTime }}</span></template>
              </jc-table-column>
              <jc-table-column :label="$t('创建时间')" width="90px">
                <template scope="scope" >{{scope.row.createTime}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('是否支持转赠')" >
                <template scope="scope" >
                  <span v-if="scope.row.resend === 1">{{$t('是')}}</span>
                  <span v-else>{{$t('否')}}</span></template>
              </jc-table-column>
              <!-- <jc-table-column :label="$t('是否支持发放代金券')"  prop="deliverCoupon">
                <template scope="scope" >
                <span v-if="scope.row.deliverCoupon === 1">{{$t('是')}}</span>
                  <span v-else>{{$t('否')}}</span></template>
              </jc-table-column> -->
              <jc-table-column :label="$t('状态')"  width="70px" prop="statusIndex">
                <template scope="scope" >{{scope.row.statusIndex | filterQuotaCouponStatus}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('操作')"  prop="couponPin">
                <template scope="scope" >
              <router-link
                class="blueLink"
                :to="`/cost/quota-coupon-detail?number=${scope.row.number}`"
              >{{$t('查看')}}</router-link
          >
          <jc-button type="text" :disabled="scope.row.statusIndex !== 3 || scope.row.isExpired " @click="issue(scope.row.number)">{{$t('发放')}}</jc-button>
          <jc-button type="text" :disabled="scope.row.resend !== 1 || scope.row.statusIndex !== 3 || scope.row.isExpired " @click="resend(scope.row.number)">{{$t('转赠')}}</jc-button>
                  </template> 

              </jc-table-column>

            </jc-table>
            <div class="btnDiv cl">
              <jc-pagination align="right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="quotaSearchParams.currentPage"
                :page-sizes="[10, 20,50]"
                :page-size="quotaSearchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="quotaTotal">
              </jc-pagination>
            </div>
           </div>
            </div>
             </div>
  </div>
</template>
<script>
import { IS_OR_NOT, STATUS_MAP } from '@/utils/constant.js'
import { getDate } from '@/utils/index'
import { describeConsoleQuotaRecord } from '@/api/coupon-api.js'
export default {
  name: 'quotaRecord',
  data() {
    return {
      IS_OR_NOT,
      STATUS_MAP,
      quotaSearchParams: {
        number: '', // 券额码
        validateTimeBegin: null, // 有效时间开始时间
        validateTimeEnd: null, // 有效时间结束时间
        createTimeBegin: null, // 创建时间开始时间
        createTimeEnd: null, // 创建时间结束时间
        resend: null, // 是否支持转赠
        status: null, // 状态
        currentPage: 1, //当前页
        pageSize: 10 //页大小
      },
      daterange: [],
      createRang: [],
      quotaList: [],
      quotaTotal: 0
    }
  },
  watch: {
    daterange(curVal) {
      this.quotaSearchParams.validateTimeBegin =
        (curVal[0] && getDate(new Date(curVal[0])).ymd + ' 00:00:00') || ''
      this.quotaSearchParams.validateTimeEnd =
        (curVal[1] && getDate(new Date(curVal[1])).ymd + ' 23:59:59') || ''
    },
    createRang(curVal) {
      this.quotaSearchParams.createTimeBegin =
        (curVal[0] && getDate(new Date(curVal[0])).ymd + ' 00:00:00') || ''
      this.quotaSearchParams.createTimeEnd =
        (curVal[1] && getDate(new Date(curVal[1])).ymd + ' 23:59:59') || ''
    }
  },
  methods: {
    async query() {
      try {
        let {
          body: {
            result: { data, pageInfo }
          }
        } = await describeConsoleQuotaRecord(this.quotaSearchParams)
        this.quotaList = this.handleTableData(data) || []
        this.quotaTotal = pageInfo.totalRecord || 0
      } catch (e) {
        console.log(e)
        this.quotaList = []
        this.quotaTotal = 0
      }
    },
    reset() {
      this.$refs['quotaSearchForm'].resetFields()
      this.createRang = []
      this.daterange = []
    },
    issue(number) {
      this.$router.push({ path: `/cost/quota-coupon-issue?number=${number}` })
    },
    resend(number) {
      this.$router.push({ path: `/cost/quota-coupon-resend?number=${number}` })
    },
    handleTableData(data) {
      let isExpired = false
      data &&
        data.map(item => {
          let date =
            item.validEndTime &&
            new Date(item.validEndTime) &&
            new Date(item.validEndTime).getTime()
          isExpired = Date.now() > date || !(item.balance >= 0.01)
          item.isExpired = isExpired
        })
      return data
    },
    handleSizeChange: function(_val) {
      this.quotaSearchParams.currentPage = 1
      this.quotaSearchParams.pageSize = _val
      this.query()
    },
    handleCurrentChange: function(_val) {
      this.quotaSearchParams.currentPage = _val
      this.query()
    }
  },
  created() {
    this.query()
  }
}
</script>
<style>
.form-tablelabel {
  margin-right: 10px;
}
</style>
